import axios from "axios";
import {
    URLAPI,
    COMPANY_PATH,
    COMPANY_CREATE_PATH,
    COMPANY_UPDATE_PATH,
} from "../config";
import {LOGOUT} from './users'

/* The initial state of the store. */
const init = {
    _get_all_companies: {
        data: [],
        status: 0,
        message: {},
    },
    _create_companies: {
        data: {},
        status: 0,
        message: {},
    },
    _update_companies: {
        data: {},
        status: 0,
        message: {},
    },
}

/* It's a constant that is being used to dispatch an action. */
const GET_ALL_COMPANIES_SUCCESS = "GET_ALL_COMPANIES_SUCCESS";
/* It's a constant that is being used to dispatch an action. */
export const CREATE_COMPANIES_SUCCESS = "CREATE_COMPANIES_SUCCESS";
/* It's a constant that is being used to dispatch an action. */
export const UPDATE_COMPANIES_SUCCESS = "UPDATE_COMPANIES_SUCCESS";


/**
 * It takes the current state and an action, and returns the next state
 * @param [state] - This is the current state of the reducer.
 * @param action - This is the action that is being dispatched.
 * @returns The state is being returned.
 */
export const company_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_COMPANIES_SUCCESS:
            return {
                ...state,
                _get_all_companies: action.payload,
            };
        case CREATE_COMPANIES_SUCCESS:
            return {
                ...state,
                _create_companies: action.payload,
            };
        case UPDATE_COMPANIES_SUCCESS:
            return {
                ...state,
                _update_companies: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}


/**
 * It's a function that returns a function that returns an object
 * @param token - The token that is returned from the login request.
 */
export const get_all_companies = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${COMPANY_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_COMPANIES_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_COMPANIES_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_COMPANIES_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al obtener las empresas",
                },
            });
        }
    }
}


/**
 * It's a function that returns a function that returns an object
 * @param token - The token that is returned from the login request.
 * @param data - The data that is being sent to the server.
 * @returns The response from the server.
 * @returns The state is being returned.
 *  */
export const create_companies = (token, data) => async (dispatch) => {
    try {

        const response = await axios.post(`${URLAPI}${COMPANY_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: CREATE_COMPANIES_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_COMPANIES_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_COMPANIES_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al crear la empresa",
                },
            });
        }
    }
}


/**
 * It's a function that returns a function that returns an object
 * @param token - The token that is returned from the login request.
 * @param id - The id of the object that is being updated.
 * @returns The response from the server.
 * @returns The state is being returned.
 * */
export const update_companies = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${COMPANY_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_COMPANIES_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_COMPANIES_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_COMPANIES_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const clear_status_companie = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}